import React from 'react'
import PropTypes from 'prop-types'
import uniqueId from 'lodash/uniqueId'
import Svg from '../../Svg'

const genId = () => uniqueId('estimatedValueTeaser')
const a = genId()
const b = genId()
const c = genId()
const d = genId()
const e = genId()
const f = genId()

const propTypes = {
  className: PropTypes.string,
}

const EstimatedValueTeaserScreen = ({ className, ...restProps }) => (
  <Svg viewBox='0 0 486 405' className={className} {...restProps}>
    <defs>
      <path id={b} d='M0 0h450v369H0z' />
      <filter
        id={a}
        width='112.4%'
        height='115.2%'
        x='-6.2%'
        y='-7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='9'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0'
        />
      </filter>
      <text
        id={d}
        fill='var(--brand-primary-600)'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='48'
        fontWeight='300'
      >
        <tspan x='123.949' y='130'>
          $482,000
        </tspan>
      </text>
      <filter
        id={c}
        width='103.1%'
        height='121.5%'
        x='-1.6%'
        y='-7.7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='2'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
      </filter>
      <text
        id={f}
        fill='var(--brand-primary-600)'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='32'
        fontWeight='300'
      >
        <tspan x='157.633' y='323'>
          $206,137
        </tspan>
      </text>
      <filter
        id={e}
        width='103.1%'
        height='132.6%'
        x='-1.6%'
        y='-11.6%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='2'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
      </filter>
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(18 16)'>
        <use
          fill='var(--brand-hb-black)'
          filter={`url(#${a})`}
          href={`#${b}`}
        />
        <use fill='var(--brand-surface-elevation-300)' href={`#${b}`} />
      </g>
      <text
        fill='var(--brand-neutral-cool-700)'
        fontFamily='OpenSans-Regular, Open Sans'
        fontSize='16'
        transform='translate(18 16)'
      >
        <tspan x='45.168' y='279'>
          That means the net worth of the home to you is:
        </tspan>
      </text>
      <text
        fill='var(--brand-neutral-cool-900)'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='22'
        fontWeight='300'
        transform='translate(18 16)'
      >
        <tspan x='46.239' y='74'>
          The estimated value of your home is
        </tspan>
      </text>
      <g fill='var(--brand-primary-600)' transform='translate(18 16)'>
        <use filter={`url(#${c})`} href={`#${d}`} />
        <use href={`#${d}`} />
      </g>
      <g fill='var(--brand-primary-600)' transform='translate(18 16)'>
        <use filter={`url(#${e})`} href={`#${f}`} />
        <use href={`#${f}`} />
      </g>
      <g stroke='var(--brand-neutral-cool-400)' strokeDasharray='1,4'>
        <path d='M43 171.5h408.362M43.297 209.5H451.66M43.297 246.5H451.66' />
      </g>
      <g transform='translate(53 156)'>
        <path
          stroke='var(--brand-primary-600)'
          strokeWidth='3'
          d='M8 80c13.431-6.333 22.012-9.5 25.743-9.5 5.596 0 25.37 9 29.847 6S81.125 58 84.11 51c2.984-7 11.565-35 23.13-35 11.566 0 21.64 14 26.117 17.5 2.984 2.333 13.555 4.5 31.712 6.5l17.535-3.5 16.789 3.5c7.71-7 13.182-10.5 16.415-10.5 4.85 0 12.685 5.5 17.162 10.5 4.477 5 11.566 23 16.79 23 3.481 0 9.326-6.667 17.534-20l15.67-33c6.88-4 12.559-6 17.036-6 6.716 0 10.572 21.5 16.914 25.5 4.229 2.667 9.825 1 16.79-5l18.28-3.5 15.67-11'
        />
        <circle cx='31.647' cy='72.5' r='3.5' fill='var(--brand-primary-600)' />
        <circle cx='48.062' cy='74.5' r='3.5' fill='var(--brand-primary-600)' />
        <circle cx='64.478' cy='76.5' r='3.5' fill='var(--brand-primary-600)' />
        <circle cx='81.64' cy='56.5' r='3.5' fill='var(--brand-primary-600)' />
        <circle cx='98.802' cy='21.5' r='3.5' fill='var(--brand-primary-600)' />
        <circle
          cx='115.964'
          cy='18.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='133.126'
          cy='32.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='149.541'
          cy='38.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='165.957'
          cy='40.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='181.627'
          cy='36.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='199.535'
          cy='39.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='215.951'
          cy='29.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='232.366'
          cy='38.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='250.274'
          cy='62.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='267.436'
          cy='43.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='283.106'
          cy='11.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle cx='300.268' cy='3.5' r='3.5' fill='var(--brand-primary-600)' />
        <circle cx='317.43' cy='28.5' r='3.5' fill='var(--brand-primary-600)' />
        <circle
          cx='334.592'
          cy='25.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <circle
          cx='350.261'
          cy='21.5'
          r='3.5'
          fill='var(--brand-primary-600)'
        />
        <g transform='translate(360.192 4)'>
          <circle
            cx='7.873'
            cy='7.5'
            r='7.5'
            fill='var(--brand-neutral-cool-50)'
            stroke='var(--brand-primary-600)'
            strokeOpacity='.7'
          />
          <circle cx='7.858' cy='7.5' r='3.5' fill='var(--brand-primary-600)' />
        </g>
        <g transform='translate(0 73)'>
          <circle
            cx='7.873'
            cy='7.5'
            r='7.5'
            fill='var(--brand-neutral-cool-50)'
            stroke='var(--brand-primary-600)'
            strokeOpacity='.7'
          />
          <circle cx='7.858' cy='7.5' r='3.5' fill='var(--brand-primary-600)' />
        </g>
      </g>
    </g>
  </Svg>
)

EstimatedValueTeaserScreen.propTypes = propTypes

export default EstimatedValueTeaserScreen
